/**
 * @file machine_app_view.js
 * @author MachineApps Team
 *
 * @description Creates a view for the machine app type provided. This is used by 'gui_pane_machineapp.js' in assembler,
 * and by the 'MachineApp' page on the pendant. The pendant version is temporary.
 */

import $ from 'jQuery';
import { machineAppItemEditor } from '../machine_app_item_editor';
import machine_app_implementation_loader from '../models/machine_app_implementation_loader';

/**
 * This functions defines the page and flow of the MachineParameter UI step in a MachineApp
 *
 * @param {machineAppLibrary} machineAppLibrary
 * @param {Function} onUpdate
 * @param {Function} listItems
 * @param {Object} flavorText
 * @param {Function} getPreview
 * @param {Object} globalAssetFlavorText
 * @returns {{body: JQuery, header: JQuery, footer: JQuery}}
 */
export function getMachineParametersView(
  machineAppLibrary,
  onUpdate,
  listItems,
  flavorText,
  getPreview,
) {

  const configurationText = machine_app_implementation_loader.instance.getFlavorText(machineAppLibrary.getType()).configuration;
  let body;
  const header = $('<h2>').text(flavorText.pluralName);
  const lParameters = listItems();

  if (getPreview) {
    const onEdit = (defaultStep) => {
      machineAppItemEditor(lParameters, onUpdate, defaultStep);
    };
    body = getPreview(lParameters, onEdit);
  }
  else {
    body = $('<div>')
      .addClass('machine_parameters_empty_page')
      .append(
        $('<button>')
          .addClass('machine_parameters_empty_page_create_button')
          .text('Edit Machine Parameters')
          .on('click', function() {
            machineAppItemEditor(lParameters, onUpdate);
          })
      );
  }


  return {
    body,
    header,
  };
}